import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import { notifyWithSoundAndVibration } from "@/lib/notifications";

/**
 * Hook joka kuuntelee uusia noutotilauksia ja näyttää ilmoitukset.
 * Käyttää Supabase Realtime -tilauksia installations-taulun muutoksiin.
 */
export function usePickupNotifications() {
  const queryClient = useQueryClient();

  useEffect(() => {
    const channel = supabase
      .channel('pickup-notifications')
      .on(
        'postgres_changes',
        {
          event: 'INSERT',
          schema: 'public',
          table: 'installations',
          filter: 'task_type=eq.pickup'
        },
        (payload) => {
          console.log('New pickup installation:', payload);
          notifyWithSoundAndVibration();
          toast.info("Uusi noutotilaus saatavilla!", {
            description: "Tarkista kartta nähdäksesi uuden noudon",
            duration: 5000,
          });
          queryClient.invalidateQueries({ queryKey: ["unassigned-pickups"] });
        }
      )
      .on(
        'postgres_changes',
        {
          event: 'UPDATE',
          schema: 'public',
          table: 'installations',
          filter: 'task_type=eq.pickup'
        },
        (payload) => {
          console.log('Pickup installation updated:', payload);
          queryClient.invalidateQueries({ queryKey: ["unassigned-pickups"] });
          queryClient.invalidateQueries({ queryKey: ["claimed-pickups"] });
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [queryClient]);
}
